import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
const { startCase,capitalize} = require('lodash')

const SubAdminView = ({ setViewShow, item }) => {
  const { t } = useTranslation()

  const [permissionJson] = useState(item?.permission,)

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto '>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[1000px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setViewShow(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
              <div className=' border-2 rounded-md p-5'>
                <div className='grid grid-cols-3 '>
                  <div className='mb-3'>
                    <div className=''><strong>{t('O_FIRST_NAME')}:</strong></div>
                    <div>{startCase(item?.firstName)}</div>
                  </div>
                  <div className='mb-3'>
                    <div className=''><strong>{t('O_LAST_NAME')}:</strong></div>
                    <div>{startCase(item?.lastName)}</div>
                  </div>
                  <div className='mb-3'>
                    <div className=''><strong>{t('O_MOBILE')}:</strong></div>
                    <div>{item?.mobile}</div>
                  </div>
                  <div className='mb-3'>
                    <div className=''><strong>{t('O_EMAIL_ID')}:</strong></div>
                    <div>{item?.email||'N/A'}</div>
                  </div>
                  <div className='mb-3'>
                    <div className=''><strong>{t('SUB_ADMIN_ADDRESS')}:</strong></div>
                    <div>{startCase(item?.address)}</div>
                  </div>
                </div>
                <div className='pl-1 pr-3 h-56 overflow-y-scroll'>
                  <div className='overflow-x-auto  overflow-y-auto relative rounded-lg border'>
                    <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
                      <thead className='text-xs  text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
                        <tr>
                          <th scope='col' className='py-3 px-6 '>
                            {t('SUB_ADMIN_MANAGER')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_VIEW')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('SUB_ADMIN_ADD_EDIT')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_DELETE')}
                          </th>
                          <th scope='col' className='py-3 px-6 '>
                            {t('O_ALL')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {permissionJson?.map((item, i) => (
                          <tr
                            key={i}
                            className='bg-white border-b  dark:bg-gray-800 dark:border-gray-700'
                          >
                            <td className='py-2 px-2 border-r '>
                            {capitalize(startCase(item.manager))}
                            </td>
                            <td className='py-2 px-2 border-r '>
                              <input
                                type='checkbox'
                                id='view'
                                checked={item.view}
                              />
                            </td>

                            <td className='py-2 px-2 border-r '>
                              <input
                                type='checkbox'
                                id='add'
                                checked={item.add}
                              />
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {
                                (item?.manager === 'settings') || (item?.manager === 'static_content') || (item?.manager === 'transaction_manager') || (item?.manager === 'dashboard') || (item?.manager === 'wallet_manager')
                                  ? null
                                  : <input type='checkbox' id='delete' checked={item.delete} />
                              }
                            </td>
                            <td className='py-2 px-2 border-r '>
                              {
                                (item?.manager === 'settings') || (item?.manager === 'static_content') || (item?.manager === 'transaction_manager') || (item?.manager === 'dashboard') || (item?.manager === 'wallet_manager')
                                  ? null
                                  : <input type='checkbox' disabled />
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>

              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setViewShow(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default SubAdminView
